import React from "react";
import "./App.css";
import { ThemeProvider } from "styled-components";
import theme from "./GlobalStyle";
import ComingSoon from "./sections/ComingSoon";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import Work from "./sections/Work";
import Problem from "./sections/Problem";
import Services from "./sections/Services";
import WhyMaintain from "./sections/WhyMaintain";
import CarePlans from "./sections/CarePlans";
import About from "./sections/About";
import Footer from "./sections/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ContactModal from "./sections/ContactModal";
import { ContactProvider } from "./contexts/ContactContext";

// Coming Soon gate. Defaults to ON: the placeholder shows unless the env var is
// explicitly set to "false". To take the full site live, set
// REACT_APP_COMING_SOON=false (e.g. in the Railway build environment).
const showComingSoon = process.env.REACT_APP_COMING_SOON !== "false";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {showComingSoon ? (
          <ComingSoon />
        ) : (
          <ContactProvider>
            <Header />
            <Hero />
            <Work />
            <Problem />
            <Services />
            <WhyMaintain />
            <CarePlans />
            <About />
            <Footer />
            <ScrollToTop />
            <ContactModal />
          </ContactProvider>
        )}
      </div>
    </ThemeProvider>
  );
}
